module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAOVBMVEWvr68AAACtra2tra2qqqqsrKyvr6+wsLCvr6+2travr6+urq6wsLCwsLCvr6+vr6+urq6wsLCwsLDTmZQUAAAAE3RSTlP/AIBXCS6/R9gOrHtahKh/pCrU51yyGQAAAHdJREFUeJxtj0sSgCAMQ1P5yV+5/2GltIwuzIJpXjNDCpqKJreWTeSZQTixdAYBh1jWwcC9HnAE62UnOW9RdlZIQVWvpCLpXjMJbef7ehsycFPndKcb0xpgXPLnNTBt1JpaNoLCF4S/6kROysI7vZZsqSnVYnl+AEhDAoaBJTn0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/collapseImg.png
// module id = vTiT
// module chunks = 0